import React from "react";
import { FOOTER } from "../../data";

export default function Footer() {
  return (
    <footer style={{ background: "#00030F", borderTop: "1px solid var(--line)", padding: "52px 0 40px" }}>
      <div className="mx-auto max-w-[1080px] px-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div className="display" style={{ fontSize: "1.3rem" }}>
            HIGHTICKET<span className="blue">SALES</span>
          </div>
          <nav className="flex flex-wrap gap-5">
            {FOOTER.links.map((l) => (
              <a key={l} href="#" style={{ color: "var(--muted)", fontSize: "0.88rem", textDecoration: "none" }}>{l}</a>
            ))}
          </nav>
        </div>

        <hr className="rule my-8" />

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <span style={{ fontSize: "0.85rem" }}>{FOOTER.email}</span>
          <span style={{ fontSize: "0.82rem", opacity: 0.7 }}>{FOOTER.company}</span>
        </div>

        <p className="mt-6" style={{ fontSize: "0.78rem", maxWidth: "72ch", lineHeight: 1.6, opacity: 0.6 }}>{FOOTER.disclaimer}</p>
        <p className="mt-4" style={{ fontSize: "0.8rem", opacity: 0.75 }}>{FOOTER.copyright}</p>
      </div>
    </footer>
  );
}
